import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { EventSettings, PrizesAdmin, CodesAdmin, PullsLog } from "@/components/admin/GachaAdmin";

const Box = ({ title, children }) => (
  <>
    <h2 className="mt-14 font-display text-2xl font-bold md:text-3xl">{title}</h2>
    <section className="mt-5 rounded-3xl bg-surface p-6 ring-1 ring-white/[0.07] md:p-8">{children}</section>
  </>
);

export default function AdminGacha() {
  return (
    <div className="grain min-h-screen bg-ink text-paper" data-testid="admin-gacha-page">
      <header className="border-b border-white/[0.07]">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
          <Logo />
          <a href="/tigasatu/dashboard" data-testid="admin-gacha-back" className="flex items-center gap-1.5 text-sm text-zinc-300 hover:text-paper"><ArrowLeft className="h-4 w-4" /> Dashboard</a>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-12">
        <h1 className="font-display text-4xl font-bold">Brewek (gacha)</h1>
        <p className="mt-2 text-zinc-400">Nyalakan saat ada event. 1 kode unik = 1 pack.</p>
        <Box title="Event"><EventSettings /></Box>
        <Box title="Daftar hadiah & rate"><PrizesAdmin /></Box>
        <Box title="Kode unik"><CodesAdmin /></Box>
        <Box title="Riwayat brewek"><PullsLog /></Box>
      </main>
    </div>
  );
}
